import equalByNameAndAssetComponentId from '../../utils/equalByNameAndAssetComponentId';
import dateConverter from '../../../../utils/converters/date.converter';
import {i18n} from "../../../vue-i18n";

export default class ChangeLiquidationValue {
    constructor(assetComponentId, newLiquidationValue) {
        this.commandName = "ChangeLiquidationValue";
        this.assetComponentId = assetComponentId;
        this.newLiquidationValue = newLiquidationValue;

        this.description = `${i18n.t('CONTENT.events.ChangeLiquidationValue')}: ${newLiquidationValue}`;
    }

    serialize() {
        return {
          commandName: this.commandName,
          serialisedCommand: JSON.stringify({
            AssetComponentId: this.assetComponentId,
            NewLiquidationValue: this.newLiquidationValue
          })
        }
      }

      equal = (other) => equalByNameAndAssetComponentId(this, other);
}
